webpackJsonp([114276838955818,60335399758886],{

/***/ 134:
/***/ (function(module, exports) {

	module.exports = {"data":{"instagram":{"edges":[{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQADAAAAAAAAAAAAAAAAAAQBAgX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAe/FVGXsCLcmqxc//8QAGxABAAICAwAAAAAAAAAAAAAAAQACAxExMkH/2gAIAQEAAQUCmcdy/Sg0ocKs8n//xAAWEQEBAQAAAAAAAAAAAAAAAAAQAjH/2gAIAQMBAT8Bws//xAAVEQEBAAAAAAAAAAAAAAAAAAAQAv/aAAgBAgEBPwEg/8QAGRABAAMBAQAAAAAAAAAAAAAAAQAQEQIh/9oACAEBAAY/AoZ0lMxdYT2//8QAHBAAAgICAwAAAAAAAAAAAAAAAAERIRAxQVGB/9oACAEBAAE/IRi8GousTo20SDscnO6Nq0NL1j//2gAMAwEAAgADAAAAENcHPP/EABcRAQEBAQAAAAAAAAAAAAAAAAEQITH/2gAIAQMBAT8QHqEHJ//EABcRAQEBAQAAAAAAAAAAAAAAAAEQESH/2gAIAQIBAT8QxYuT/8QAHBABAQEAAwADAAAAAAAAAAAAAREAITFBEFHR/9oACAEBAAE/EMuRgCKv0e/HAlWADNRhAbUPNa3aLgWryT8whAPUwQA6N//Z","aspectRatio":1,"src":"/static/instagram-1-fc154638a3d9b82210b0c8272ab9fb6b-0f510.jpg","srcSet":"/static/instagram-1-fc154638a3d9b82210b0c8272ab9fb6b-8b87b.jpg 75w,\n/static/instagram-1-fc154638a3d9b82210b0c8272ab9fb6b-90693.jpg 150w,\n/static/instagram-1-fc154638a3d9b82210b0c8272ab9fb6b-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAECBQME/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIQAxAAAAHEve9HBI2rJNeQD//EAB0QAAIBBAMAAAAAAAAAAAAAAAECAAMQERITISL/2gAIAQEAAQUCjACwRsMrETY8jdUz7n//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAWEQEBAQAAAAAAAAAAAAAAAAABICH/2gAIAQIBAT8BDI//xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIRECFBEv/aAAgBAQAGPwI1hSEqw4c8l9La2f/EABsQAAMBAQADAAAAAAAAAAAAAAABESExQWFx/9oACAEBAAE/IUtREqkE4M6IQ3w5jFpPUKoljyRjNj//2gAMAwEAAgADAAAAEPvHfP/EABgRAQADAQAAAAAAAAAAAAAAAAEAEBEh/9oACAEDAQE/EO7RENn/xAAZEQEAAgMAAAAAAAAAAAAAAAABACEQETH/2gAIAQIBAT8Qs1gU5Ns//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSFBYf/aAAgBAQABPxAEnF7G0wauHEGrMGvI3IDrVhdgpGkTJlAhPqOSUWLeQMBjqFXP/9k=","aspectRatio":1,"src":"/static/instagram-10-4159f0487efdc38bad9837fbd458447e-0f510.jpg","srcSet":"/static/instagram-10-4159f0487efdc38bad9837fbd458447e-8b87b.jpg 75w,\n/static/instagram-10-4159f0487efdc38bad9837fbd458447e-90693.jpg 150w,\n/static/instagram-10-4159f0487efdc38bad9837fbd458447e-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEAgX/xAAXAQEBAQEAAAAAAAAAAAAAAAACAAED/9oADAMBAAIQAxAAAAGfVM5XqMA7aB1ExX//xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBEyEv/aAAgBAQABBQLyIXepgwYZI1CC61WKq3dPE5//xAAVEQEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAwEBPwGD/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8BI//EAB0QAAICAQUAAAAAAAAAAAAAAAABAhEQEiExUXL/2gAIAQEABj8CipLSLe49MtCSFfKKZDyVj//EABwQAQEAAgIDAAAAAAAAAAAAAAEAESExQVFhkf/aAAgBAQABPyHchk7belIIppuvXnUyPHyux2Z59xuPgEBF/9oADAMBAAIAAwAAABCU4H7/xAAXEQEBAQEAAAAAAAAAAAAAAAABACER/9oACAEDAQE/EBBtlzSXb//EABgRAQEAAwAAAAAAAAAAAAAAAAEAEBEh/9oACAECAQE/EFLaTAcv/8QAHRABAQEBAAIDAQAAAAAAAAAAAREAITHxUWGBsf/aAAgBAQABPxCj9Ycq/E/eYEgLxp3xdYMFMxBEA+Q2jvrhAD20mULtO7rwqFDrfeJJIJA1QDk/m//Z","aspectRatio":1,"src":"/static/instagram-11-e0e9aba638a101a8ea635f7157a4c587-0f510.jpg","srcSet":"/static/instagram-11-e0e9aba638a101a8ea635f7157a4c587-8b87b.jpg 75w,\n/static/instagram-11-e0e9aba638a101a8ea635f7157a4c587-90693.jpg 150w,\n/static/instagram-11-e0e9aba638a101a8ea635f7157a4c587-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUCA//EABYBAQEBAAAAAAAAAAAAAAAAAAACAf/aAAwDAQACEAMQAAABh1J9eahjZzs1zB//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADEQQU/9oACAEBAAEFAjPMipkALv0WFa9gOFnZzP/EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAEDAQE/ASP/xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPwFj/8QAGRAAAgMBAAAAAAAAAAAAAAAAAREAEDEC/9oACAEBAAY/AoT08oAbFjpx9F1//8QAHBABAAICAwEAAAAAAAAAAAAAAQARECExQWGB/9oACAEBAAE/IRuu4Etp8YbgbcQGEQqo+YgBpO5cGvcf/9oADAMBAAIAAwAAABCI7zz/xAAWEQEBAQAAAAAAAAAAAAAAAAABIDH/2gAIAQMBAT8QJrH/xAAWEQEBAQAAAAAAAAAAAAAAAAARASD/2gAIAQIBAT8QSTH/xAAeEAEAAwABBQEAAAAAAAAAAAABABEhURAxYXGhwf/aAAgBAQABPxCsE1Lh0saT45I1r1CAFsco7wCZrmo/ksc+okJVgaRh4GKFdun/2Q==","aspectRatio":1,"src":"/static/instagram-12-71a99535c5981df9723770d03b9ae5f1-0f510.jpg","srcSet":"/static/instagram-12-71a99535c5981df9723770d03b9ae5f1-8b87b.jpg 75w,\n/static/instagram-12-71a99535c5981df9723770d03b9ae5f1-90693.jpg 150w,\n/static/instagram-12-71a99535c5981df9723770d03b9ae5f1-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAUDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAADAgT/2gAMAwEAAhADEAAAAZFiTaLXAcJl01IfzCy//8QAHBAAAQQDAQAAAAAAAAAAAAAAAQACAxESIjEz/9oACAEBAAEFAmC1E3FS+rOg6yHJ7DRkNyHv/8QAGREAAgMBAAAAAAAAAAAAAAAAABEBAjEQ/9oACAEDAQE/AWqoneW0/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQQf/aAAgBAgEBPwHaj//EABoQAAICAwAAAAAAAAAAAAAAAAABAhAxUXH/2gAIAQEABj8CMEhU3unyv//EABwQAAICAwEBAAAAAAAAAAAAAAERACExQVEQYf/aAAgBAQABPyFgCGvjhx7Ai7EDW4JQCDu9T6OcK8dhmuPL/9oADAMBAAIAAwAAABCfOML/xAAWEQEBAQAAAAAAAAAAAAAAAAAAMQH/2gAIAQMBAT8QkLMuKv/EABgRAAMBAQAAAAAAAAAAAAAAAAABETFB/9oACAECAQE/EGrQsH0wf//EAB4QAQEBAAIBBQAAAAAAAAAAAAERACExUUFhcZHR/9oACAEBAAE/EDcQHPsKIXn83mf+w3nKgIHLO8MtDQ5Hneu1ftq3KDvK8cQDo4xGpPjf/9k=","aspectRatio":1,"src":"/static/instagram-2-aaae8b4de1a2d56e745d12ac1506b53f-0f510.jpg","srcSet":"/static/instagram-2-aaae8b4de1a2d56e745d12ac1506b53f-8b87b.jpg 75w,\n/static/instagram-2-aaae8b4de1a2d56e745d12ac1506b53f-90693.jpg 150w,\n/static/instagram-2-aaae8b4de1a2d56e745d12ac1506b53f-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIDAQT/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB9Mah4om1g2G//8QAGxAAAgIDAQAAAAAAAAAAAAAAAQIAEBExMkH/2gAIAQEAAQUCblgorYZCZgz2v//EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAEDAQE/ASP/xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPwFj/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAECEDEREv/aAAgBAQAGPwJkPMOO9MFf/8QAHRAAAgEEAwAAAAAAAAAAAAAAAREAIUFRYRAxgf/aAAgBAQABPyFwoV1LmLCQicIPREZq1iKuiXoIAOP/2gAMAwEAAgADAAAAEKjvwP/EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEx/9oACAEDAQE/EMFOf//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEx/9oACAECAQE/EGLQ9j//xAAdEAEAAgIDAQEAAAAAAAAAAAABABEhMUFhgXGx/9oACAEBAAE/ELozSg2hNgBkNhpH6R3ERgkeZ1aPDD99gKnwiAmCqOjUtGNwCjE//9k=","aspectRatio":1,"src":"/static/instagram-3-d41f200dfb8a3d32d352c24bc9544eae-0f510.jpg","srcSet":"/static/instagram-3-d41f200dfb8a3d32d352c24bc9544eae-8b87b.jpg 75w,\n/static/instagram-3-d41f200dfb8a3d32d352c24bc9544eae-90693.jpg 150w,\n/static/instagram-3-d41f200dfb8a3d32d352c24bc9544eae-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgUD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgQD/9oADAMBAAIQAxAAAAG/jdGMutOQ9sCw1FMP/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIDEQAEEBIiMv/aAAgBAQABBQKR+MZsNRyY3EexbUG28INv/8QAGxEAAgEFAAAAAAAAAAAAAAAAAAECEBESIjH/2gAIAQMBAT8Bjy5kRb0p/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQEVL/2gAIAQIBAT8BZRqP/8QAHhAAAgEDBQAAAAAAAAAAAAAAABEBAhAyEiFRYZH/2gAIAQEABj8C7HqbMo8KZ4I2MKhX/8QAHBABAAICAwEAAAAAAAAAAAAAAQARITFBUXGx/9oACAEBAAE/Ia6sLBAZlLJc709gAabikpRBrUJ901cIF6lz/9oADAMBAAIAAwAAABC04AD/xAAZEQEBAAMBAAAAAAAAAAAAAAABABEhMcH/2gAIAQMBAT8QBGLvUDEenk9v/8QAGBEBAQEBAQAAAAAAAAAAAAAAAQARIWH/2gAIAQIBAT8QXcuJDH7F/8QAHRABAQACAwADAAAAAAAAAAAAAREAITFBUWGBkf/aAAgBAQABPxC3uH8t4CEULIvneSUhvpPjfWX1QTfW79YQzBEBxbi8GPUFxaWr4MHRDMUaHP/Z","aspectRatio":1,"src":"/static/instagram-4-47ef5e015b8e48bfb333c347d608ac39-0f510.jpg","srcSet":"/static/instagram-4-47ef5e015b8e48bfb333c347d608ac39-8b87b.jpg 75w,\n/static/instagram-4-47ef5e015b8e48bfb333c347d608ac39-90693.jpg 150w,\n/static/instagram-4-47ef5e015b8e48bfb333c347d608ac39-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAUCAwb/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAZPoJ9EYTRLvcNaEf//EABwQAAMAAgMBAAAAAAAAAAAAAAECAwAREhQhMv/aAAgBAQABBQLXJoyEg3102zblWRkMHNJYPR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAEAAgIDAQAAAAAAAAAAAAABAAIRIRASMYH/2gAIAQEABj8CKk0fYzPbcwDVmEhZ95//xAAbEAADAQEAAwAAAAAAAAAAAAAAARExIUFRYf/aAAgBAQABPyFtuGVi25rWdvmtmMI6N3APMKz34QNr0I5G0f/aAAwDAQACAAMAAAAQ48cB/8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQMBAT8QCP/EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAECAQE/EFj/xAAcEAEBAQACAwEAAAAAAAAAAAABEQAhYTFBUYH/2gAIAQEAAT8QUEF966edQW+dfmBxKqfOcoxXID2cnODyUEoWdXXqktCj3cecLYh5m8F0Glet/9k=","aspectRatio":1,"src":"/static/instagram-5-b78a5e8f2c4eddf7966a1bc72639b56a-0f510.jpg","srcSet":"/static/instagram-5-b78a5e8f2c4eddf7966a1bc72639b56a-8b87b.jpg 75w,\n/static/instagram-5-b78a5e8f2c4eddf7966a1bc72639b56a-90693.jpg 150w,\n/static/instagram-5-b78a5e8f2c4eddf7966a1bc72639b56a-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCA//EABUBAQEAAAAAAAAAAAAAAAAAAAMB/9oADAMBAAIQAxAAAAGlPqN1aKE9ATZCF//EABwQAAICAgMAAAAAAAAAAAAAAAECAAMREhMiM//aAAgBAQABBQK0nIwpMs7X6Pyyr0ZjtP/EABoRAAEFAQAAAAAAAAAAAAAAAAABAxASMSH/2gAIAQMBAT8BryHdF0//xAAZEQACAwEAAAAAAAAAAAAAAAAAMQECEBH/2gAIAQIBAT8B7lEQj//EABsQAQACAgMAAAAAAAAAAAAAAAEAEAIRMUFx/9oACAEBAAY/AjA7mq1B5KWHlf/EABsQAQADAQEBAQAAAAAAAAAAAAEAITERcRBh/9oACAEBAAE/IcG6X8h4IHcuC50Y86QJi4W5HZZlvyTtvs//2gAMAwEAAgADAAAAELPPAP/EABwRAAIABwAAAAAAAAAAAAAAAAABEBEhMVGBsf/aAAgBAwEBPxCRIniD066Xj//EABoRAAICAwAAAAAAAAAAAAAAAAABETEQUYH/2gAIAQIBAT8Qm3K3i7pUf//EAB4QAQACAQQDAAAAAAAAAAAAAAEAESEQMUFRYXGB/9oACAEBAAE/EEIKsDgeZigdgvdb4YPGNfoMFp2htHg5e2k9mo0vshkKKTX2pavqP//Z","aspectRatio":1,"src":"/static/instagram-6-79ac8b86ee57ff950e207d6ba394d6fb-0f510.jpg","srcSet":"/static/instagram-6-79ac8b86ee57ff950e207d6ba394d6fb-8b87b.jpg 75w,\n/static/instagram-6-79ac8b86ee57ff950e207d6ba394d6fb-90693.jpg 150w,\n/static/instagram-6-79ac8b86ee57ff950e207d6ba394d6fb-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQEAAwAAAAAAAAAAAAAAAAQCAQMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAfConvI3BOrQuQf/xAAcEAEAAQQDAAAAAAAAAAAAAAABAgADEBEEEjH/2gAIAQEAAQUCDbcssI6o95K9Bwq4/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQMFAAAAAAAAAAAAAAAAAQAQIQIREiJR/9oACAEBAAY/AgOrKWCp2u8t/8QAHBAAAgICAwAAAAAAAAAAAAAAAREAMRAhQVGR/9oACAEBAAE/IThLKB5C3MGkP0uIBQ2hNOFvQLH/2gAMAwEAAgADAAAAEFP3PP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EAB0QAQEAAQQDAAAAAAAAAAAAAAERACExQWEQcYH/2gAIAQEAAT8QFOgAw24QMAc99YDsyhOjEG5k3LVZBm9fumBPHjVayPoy5//Z","aspectRatio":1,"src":"/static/instagram-7-cbba5c6407f3f7b5477c59c8d5503cc0-0f510.jpg","srcSet":"/static/instagram-7-cbba5c6407f3f7b5477c59c8d5503cc0-8b87b.jpg 75w,\n/static/instagram-7-cbba5c6407f3f7b5477c59c8d5503cc0-90693.jpg 150w,\n/static/instagram-7-cbba5c6407f3f7b5477c59c8d5503cc0-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQBAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAaoqsg1yrU+Qugf/xAAZEAACAwEAAAAAAAAAAAAAAAAAAgEREjL/2gAIAQEAAQUC1S7Y1LLTDqRzck9H/8QAFREBAQAAAAAAAAAAAAAAAAAAEAH/2gAIAQMBAT8BIf/EABYRAQEBAAAAAAAAAAAAAAAAAAEQAv/aAAgBAgEBPwFzGf/EABwQAAEEAwEAAAAAAAAAAAAAAAABAiFxECBBUf/aAAgBAQAGPwJvYw1V8EgsbWn/xAAaEAADAQEBAQAAAAAAAAAAAAABESEAQRAx/9oACAEBAAE/ISawilzFZQKB3YGFyx8OqSjCTwIfcMr6f//aAAwDAQACAAMAAAAQo/8APP/EABgRAQADAQAAAAAAAAAAAAAAAAEAECEx/9oACAEDAQE/EAF2HLf/xAAWEQEBAQAAAAAAAAAAAAAAAAARASD/2gAIAQIBAT8QiuH/xAAcEAEBAQEBAAMBAAAAAAAAAAABESEAMUFRgbH/2gAIAQEAAT8QS46hRG8anA2/fn87WF6rdrwmchSNdJzmDoPkjM6mGCJPmvOUrR7bfzhZ73//2Q==","aspectRatio":1,"src":"/static/instagram-8-1100dbf7081abc83d1d6e2804eac98c0-0f510.jpg","srcSet":"/static/instagram-8-1100dbf7081abc83d1d6e2804eac98c0-8b87b.jpg 75w,\n/static/instagram-8-1100dbf7081abc83d1d6e2804eac98c0-90693.jpg 150w,\n/static/instagram-8-1100dbf7081abc83d1d6e2804eac98c0-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}},{"node":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAEEAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAaqMg9qDFmyFcsU//8QAGxABAQACAwEAAAAAAAAAAAAAAgEDBBESISL/2gAIAQEAAQUCb7DLIDi5oB7YKeGvh6Yi14Zdnc8z/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAABICH/2gAIAQMBAT8BDI//xAAVEQEBAAAAAAAAAAAAAAAAAAABIP/aAAgBAgEBPwFY/8QAIBAAAgECBwEAAAAAAAAAAAAAAQIAEjEQESFBUVJxkf/aAAgBAQAGPwJWN6YhXfAfIq3pFoVGgik8x8+oh8n/xAAbEAEAAwEAAwAAAAAAAAAAAAABABEhMUGx0f/aAAgBAQABPyHDek68jduK0x2guU3nWXlnRQ3WhwnagUp9f3ZwvI9T/9oADAMBAAIAAwAAABDbAD//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQIf/aAAgBAwEBPxC7ZeIZ/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERITH/2gAIAQIBAT8Qgyk1i4f/xAAeEAEBAAICAgMAAAAAAAAAAAABEQAhMWFB4VGBsf/aAAgBAQABPxDkAtZC1NYoTpXuZbPHvAQ1qWY80pyKFHvRhrEAZsFodax1qjTgdn7hgLDjrnB+ZT79BnwGlx//2Q==","aspectRatio":1,"src":"/static/instagram-9-15e3ae3dd5e169496e962a05ead49ba2-0f510.jpg","srcSet":"/static/instagram-9-15e3ae3dd5e169496e962a05ead49ba2-8b87b.jpg 75w,\n/static/instagram-9-15e3ae3dd5e169496e962a05ead49ba2-90693.jpg 150w,\n/static/instagram-9-15e3ae3dd5e169496e962a05ead49ba2-0f510.jpg 300w","sizes":"(max-width: 300px) 100vw, 300px"}}}}]}},"layoutContext":{}}

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(252);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(134);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(107);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(8),
	    getRawTag = __webpack_require__(33),
	    objectToString = __webpack_require__(34);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(8);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(21);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10),
	    now = __webpack_require__(497),
	    toNumber = __webpack_require__(503);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(9),
	    isObjectLike = __webpack_require__(13);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(3);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(495),
	    isObject = __webpack_require__(10);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10),
	    isSymbol = __webpack_require__(17);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Copyright = function Copyright() {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)({
	        color: '#999',
	        fontSize: '.8em',
	        padding: '20px 20px 40px',
	
	        '@media (min-width: 700px)': {
	          paddingTop: 0
	        }
	      })
	    },
	    'Copyright \xA9 ',
	    new Date().getFullYear(),
	    ' Patr\xEDcia Marques. All rights reserved. Some of the images may be property of third parties.'
	  );
	};
	
	exports.default = Copyright;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InstagramMural = __webpack_require__(247);
	
	var _InstagramMural2 = _interopRequireDefault(_InstagramMural);
	
	var _FooterMenu = __webpack_require__(243);
	
	var _FooterMenu2 = _interopRequireDefault(_FooterMenu);
	
	var _Copyright = __webpack_require__(241);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var instagram = _ref.instagram;
	  return _react2.default.createElement(
	    'footer',
	    {
	      className: (0, _emotion.css)({
	        backgroundColor: '#f6f6f6',
	        position: 'relative',
	
	        '@media (min-width: 700px)': {
	          marginTop: 120
	        }
	      })
	    },
	    _react2.default.createElement(_InstagramMural2.default, { images: instagram.edges }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)({
	          margin: '0 auto',
	          maxWidth: 600
	        })
	      },
	      _react2.default.createElement(_FooterMenu2.default, null),
	      _react2.default.createElement(_Copyright2.default, null)
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterMenu = function FooterMenu() {
	  return _react2.default.createElement(
	    'nav',
	    null,
	    _react2.default.createElement(
	      'ul',
	      {
	        className: (0, _emotion.css)({
	          listStyle: 'none',
	          margin: 0,
	          padding: '60px 20px 0',
	
	          li: {
	            display: 'inline-block',
	            margin: '0 10px 0 0'
	          },
	
	          a: {
	            border: 0,
	            color: '#333',
	            fontSize: '.8rem',
	            fontWeight: 600,
	            letterSpacing: 1,
	            textDecoration: 'underline'
	          }
	        })
	      },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: 'privacy' },
	          'Privacy Policy'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: 'terms' },
	          'Terms'
	        )
	      )
	    )
	  );
	};
	
	exports.default = FooterMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(55);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _throttle = __webpack_require__(502);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(39);
	
	var _arrowLeft = __webpack_require__(261);
	
	var _close = __webpack_require__(262);
	
	var _menu = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavButton = /*#__PURE__*/(0, _reactEmotion2.default)('button', {
	  target: 'e44tsfq0'
	})(function () {
	  return {
	    backgroundColor: 'transparent',
	    border: 0,
	    boxSizing: 'content-box',
	    height: '1em',
	    padding: '1em',
	    width: '1em',
	
	    '&:hover': {
	      backgroundColor: 'rgba(0, 0, 0, .1)'
	    },
	
	    svg: {
	      verticalAlign: 'top'
	    }
	  };
	});
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      visible: typeof window !== 'undefined' && window.scrollY < 70,
	      scroll: typeof window !== 'undefined' ? window.scrollY : 0,
	      atTop: typeof window !== 'undefined' && window.scrollY === 0
	    }, _this.handleScroll = function () {
	      if (typeof window === 'undefined') return;
	      _this.setState(function (prevState, props) {
	        return {
	          visible: prevState.scroll > window.scrollY || window.scrollY < 70,
	          scroll: window.scrollY,
	          atTop: window.scrollY < 10
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window === 'undefined') return;
	    window.addEventListener('scroll', (0, _throttle2.default)(this.handleScroll, 100));
	  };
	
	  Header.prototype.render = function render() {
	    var _props = this.props,
	        isHomepage = _props.isHomepage,
	        workSingle = _props.workSingle,
	        menuToggle = _props.menuToggle,
	        isOpen = _props.isOpen,
	        goBack = _props.goBack;
	
	    return _react2.default.createElement(
	      'header',
	      {
	        className: (0, _emotion.css)({
	          backgroundColor: '#fff',
	          boxShadow: this.state.visible && !this.state.atTop ? '0 0px 4px rgba(0, 0, 0, .1), 0 3px 8px rgba(0, 0, 0, .1)' : '',
	          display: 'flex',
	          justifyContent: 'space-between',
	          left: 0,
	          position: this.state.atTop ? 'absolute' : 'fixed',
	          top: 0,
	          transform: this.state.visible ? 'translateY(0)' : 'translateY(-100%)',
	          transition: 'transform .3s ease',
	          width: '100%',
	          zIndex: 10
	        })
	      },
	      _react2.default.createElement(
	        'nav',
	        {
	          className: (0, _emotion.css)({
	            alignItems: 'center',
	            display: 'flex',
	            justifyContent: 'space-between',
	            margin: '0 auto',
	            maxWidth: 800,
	            padding: 10,
	            width: '100%'
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          workSingle && _react2.default.createElement(
	            NavButton,
	            { onClick: function onClick() {
	                return goBack();
	              } },
	            _react2.default.createElement(_arrowLeft.ReactComponent, null)
	          ),
	          !workSingle && !isHomepage && _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/',
	              className: (0, _emotion.merge)((0, _emotion.css)({
	                fontFamily: 'Raleway',
	                textTransform: 'uppercase'
	              }) + (' ' + _styles.UnstyledLink))
	            },
	            'Patr\xEDcia Marques'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            NavButton,
	            { onClick: function onClick() {
	                return menuToggle();
	              } },
	            !isOpen && _react2.default.createElement(_menu.ReactComponent, null),
	            isOpen && _react2.default.createElement(_close.ReactComponent, null)
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(50);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(404);
	
	var _elevation = __webpack_require__(176);
	
	var _elevation2 = _interopRequireDefault(_elevation);
	
	var _instagram = __webpack_require__(263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var followButton = /*#__PURE__*/(0, _emotion.css)({
	  alignItems: 'center',
	  backgroundColor: '#fff',
	  border: 0,
	  borderRadius: 4,
	  boxShadow: (0, _elevation2.default)(2),
	  display: 'flex',
	  fontSize: '.85rem',
	  justifyContent: 'center',
	  left: '50%',
	  lineHeight: 1,
	  minWidth: 200,
	  padding: '15px 20px',
	  position: 'absolute',
	  textDecoration: 'none',
	  textTransform: 'uppercase',
	  top: '50%',
	  transform: 'translate(-50%, -50%)',
	  whiteSpace: 'nowrap'
	});
	
	var InstagramMural = function InstagramMural(_ref) {
	  var images = _ref.images;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)({
	        position: 'relative',
	
	        '@media (min-width: 700px)': {
	          transform: 'translateY(-50%)'
	        }
	      })
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)({
	          margin: '0 auto',
	          maxWidth: 700,
	
	          '.gatsby-image-outer-wrapper': {
	            display: 'inline-block',
	            boxShadow: (0, _elevation2.default)(5),
	            opacity: .8,
	            verticalAlign: 'top',
	            width: '25%',
	
	            '&:hover': {
	              opacity: 1
	            },
	
	            '@media (min-width: 700px)': {
	              width: '16.6666%',
	
	              '&:nth-child(6n)': {
	                width: '16.667%'
	              }
	            }
	          }
	        })
	      },
	      images.map(function (image, index) {
	        return _react2.default.createElement(_gatsbyImage2.default, { backgroundColor: true, key: index, sizes: image.node.childImageSharp.sizes });
	      })
	    ),
	    _react2.default.createElement(
	      _gatsbyPluginGoogleAnalytics.OutboundLink,
	      {
	        className: followButton,
	        href: 'https://www.instagram.com/patriciamarques.artist/',
	        title: 'Get in touch through Instagram'
	      },
	      _react2.default.createElement(_instagram.ReactComponent, {
	        className: (0, _emotion.css)({ marginRight: 10, width: '1.5em', height: '1.5em' })
	      }),
	      'Follow on Instagram'
	    )
	  );
	};
	
	exports.default = InstagramMural;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(55);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styles = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Screen = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ebvgu340'
	})(function (_ref) {
	  var isOpen = _ref.isOpen;
	  return {
	    backgroundColor: 'rgba(0, 0, 0, .05)',
	    bottom: 0,
	    height: '100vh',
	    left: 0,
	    opacity: isOpen ? 1 : 0,
	    position: 'absolute',
	    transition: 'opacity .3s ease',
	    width: '100vw',
	    zIndex: -1
	  };
	});
	
	var MenuLink = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'ebvgu341'
	})(function (_ref2) {
	  var active = _ref2.active;
	  return {
	    border: 0,
	    color: active ? '#000' : '#b8b8b8',
	    display: 'block',
	    fontFamily: '"Raleway"',
	    fontSize: '1.3em',
	    letterSpacing: 2,
	    padding: 30,
	    position: 'relative',
	    textAlign: 'center',
	
	    '&::after': {
	      backgroundColor: '#eee',
	      bottom: 0,
	      content: '""',
	      display: 'block',
	      height: 2,
	      left: 'calc(50% - 20px)',
	      position: 'absolute',
	      width: 40
	    }
	  };
	});
	
	var Menu = function Menu(props) {
	  return _react2.default.createElement(
	    'nav',
	    {
	      className: (0, _emotion.css)({
	        bottom: 0,
	        display: props.isOpen ? 'block' : 'none',
	        left: 0,
	        position: 'fixed',
	        right: 0,
	        width: '100%',
	        zIndex: 5
	      })
	    },
	    _react2.default.createElement(Screen, { isOpen: props.isOpen, onClick: function onClick() {
	        return props.menuToggle();
	      } }),
	    _react2.default.createElement(
	      'ul',
	      {
	        className: (0, _emotion.css)({
	          backgroundColor: '#fff',
	          boxShadow: '0 -10px 20px rgba(0, 0, 0, .1), 0 -30px 40px rgba(0, 0, 0, .1)',
	          listStyle: 'none',
	          margin: 0,
	          padding: '0 30px 30px',
	          transform: props.isOpen ? 'translateY(0)' : 'translateY(150%)',
	          transition: 'transform .3s ease',
	
	          li: { margin: 0 }
	        })
	      },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          MenuLink,
	          {
	            onClick: function onClick() {
	              return props.menuToggle();
	            },
	            active: props.pathname === '/' ? 1 : 0,
	            to: '/'
	          },
	          'Home'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          MenuLink,
	          {
	            onClick: function onClick() {
	              return props.menuToggle();
	            },
	            active: props.pathname === '/portfolio' ? 1 : 0,
	            to: '/portfolio'
	          },
	          'Portfolio'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          MenuLink,
	          {
	            onClick: function onClick() {
	              return props.menuToggle();
	            },
	            active: props.pathname === '/about' ? 1 : 0,
	            to: '/about'
	          },
	          'About'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            className: _styles.Button,
	            href: 'mailto:contacto@patriciamarques.me',
	            title: 'Get in touch'
	          },
	          'Contact'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.workQuery = undefined;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(245);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(242);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(248);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper(props) {
	    _classCallCheck(this, TemplateWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { isOpen: false };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  TemplateWrapper.prototype.toggle = function toggle() {
	    this.setState(function (prevState) {
	      return { isOpen: !prevState.isOpen };
	    });
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history,
	        children = _props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Patr\xEDcia Marques \u2013 Makeup Artist',
	        meta: [{ name: 'description', content: 'Makeup Artist sharing her work and emotions through different Makeup styles and techniques: TV&Cinema, Fashion, Brides, Events, Airbrush&Body Painting.' }, { name: 'keywords', content: 'makeup, artist, tv, cinema, theater, advertising, brides, events' }]
	      }),
	      _react2.default.createElement(_Header2.default, {
	        isHomepage: location.pathname === '/',
	        workSingle: location.pathname.match(/^\/work\//) !== null,
	        isOpen: this.state.isOpen,
	        menuToggle: this.toggle,
	        goBack: history.goBack
	      }),
	      _react2.default.createElement(_Menu2.default, {
	        pathname: location.pathname,
	        isOpen: this.state.isOpen,
	        menuToggle: this.toggle
	      }),
	      _react2.default.createElement(
	        'main',
	        {
	          className: (0, _emotion.css)({ maxWidth: 600, margin: '70px auto 0' })
	        },
	        children()
	      ),
	      _react2.default.createElement(_Footer2.default, { instagram: this.props.data.instagram })
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	exports.default = TemplateWrapper;
	var workQuery = exports.workQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M3.828 9l6.071-6.071-1.414-1.414L0 10l.707.707 7.778 7.778 1.414-1.414L3.828 11H20V9H3.828z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 20 20",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBvbHlnb24gcG9pbnRzPSIzLjgyOCA5IDkuODk5IDIuOTI5IDguNDg1IDEuNTE1IDAgMTAgLjcwNyAxMC43MDcgOC40ODUgMTguNDg1IDkuODk5IDE3LjA3MSAzLjgyOCAxMSAyMCAxMSAyMCA5IDMuODI4IDkiLz48L3N2Zz4=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 20 20",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDguNTg2TDIuOTI5IDEuNTE1IDEuNTE1IDIuOTI5IDguNTg2IDEwbC03LjA3MSA3LjA3MSAxLjQxNCAxLjQxNEwxMCAxMS40MTRsNy4wNzEgNy4wNzEgMS40MTQtMS40MTRMMTEuNDE0IDEwbDcuMDcxLTcuMDcxLTEuNDE0LTEuNDE0TDEwIDguNTg2eiIvPjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  fill: "currentColor",
	  d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 448 512",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTIyNC4xIDE0MWMtNjMuNiAwLTExNC45IDUxLjMtMTE0LjkgMTE0LjlzNTEuMyAxMTQuOSAxMTQuOSAxMTQuOVMzMzkgMzE5LjUgMzM5IDI1NS45IDI4Ny43IDE0MSAyMjQuMSAxNDF6bTAgMTg5LjZjLTQxLjEgMC03NC43LTMzLjUtNzQuNy03NC43czMzLjUtNzQuNyA3NC43LTc0LjcgNzQuNyAzMy41IDc0LjcgNzQuNy0zMy42IDc0LjctNzQuNyA3NC43em0xNDYuNC0xOTQuM2MwIDE0LjktMTIgMjYuOC0yNi44IDI2LjgtMTQuOSAwLTI2LjgtMTItMjYuOC0yNi44czEyLTI2LjggMjYuOC0yNi44IDI2LjggMTIgMjYuOCAyNi44em03Ni4xIDI3LjJjLTEuNy0zNS45LTkuOS02Ny43LTM2LjItOTMuOS0yNi4yLTI2LjItNTgtMzQuNC05My45LTM2LjItMzctMi4xLTE0Ny45LTIuMS0xODQuOSAwLTM1LjggMS43LTY3LjYgOS45LTkzLjkgMzYuMXMtMzQuNCA1OC0zNi4yIDkzLjljLTIuMSAzNy0yLjEgMTQ3LjkgMCAxODQuOSAxLjcgMzUuOSA5LjkgNjcuNyAzNi4yIDkzLjlzNTggMzQuNCA5My45IDM2LjJjMzcgMi4xIDE0Ny45IDIuMSAxODQuOSAwIDM1LjktMS43IDY3LjctOS45IDkzLjktMzYuMiAyNi4yLTI2LjIgMzQuNC01OCAzNi4yLTkzLjkgMi4xLTM3IDIuMS0xNDcuOCAwLTE4NC44ek0zOTguOCAzODhjLTcuOCAxOS42LTIyLjkgMzQuNy00Mi42IDQyLjYtMjkuNSAxMS43LTk5LjUgOS0xMzIuMSA5cy0xMDIuNyAyLjYtMTMyLjEtOWMtMTkuNi03LjgtMzQuNy0yMi45LTQyLjYtNDIuNi0xMS43LTI5LjUtOS05OS41LTktMTMyLjFzLTIuNi0xMDIuNyA5LTEzMi4xYzcuOC0xOS42IDIyLjktMzQuNyA0Mi42LTQyLjYgMjkuNS0xMS43IDk5LjUtOSAxMzIuMS05czEwMi43LTIuNiAxMzIuMSA5YzE5LjYgNy44IDM0LjcgMjIuOSA0Mi42IDQyLjYgMTEuNyAyOS41IDkgOTkuNSA5IDEzMi4xczIuNyAxMDIuNy05IDEzMi4xeiI+PC9wYXRoPgo8L3N2Zz4K";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 20 20",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTAgM2gyMHYySDBWM3ptMCA2aDIwdjJIMFY5em0wIDZoMjB2Mkgwdi0yeiIvPjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a84c9e9196c1021af206.js